import { ListItem, Table } from '@mui/material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableCell,
  TableRow,
} from '@material-ui/core'
import TableHead from '@mui/material/TableHead'
import { InputSelectConsent } from './InputSelectConsent'
import moment from 'moment/moment'

export const DialogCoownerDetail = ({
  coownerDetail,
  refresh,
  closeDialog,
}) => {
  const formatTownAndZipCode = (town, zipCode) => {
    if (town && zipCode) return `${town} - ${zipCode}`
    if (town) return `${town}`
    if (zipCode) return `${zipCode}`
    return '-'
  }

  return (
    <>
      <Dialog
        aria-labelledby="modal-comments"
        fullWidth
        maxWidth="xl"
        disableEnforceFocus
        open={true}
        onClose={closeDialog}
      >
        <DialogTitle>
          Contacts du copropriétaire {coownerDetail.libelle}
        </DialogTitle>
        <DialogContent>
          <Table sx={{ minWidth: 650 }} size="small">
            <TableHead>
              <TableRow>
                <TableCell>Libellé</TableCell>
                <TableCell>Mail</TableCell>
                <TableCell>Adresse</TableCell>
                <TableCell>Ville</TableCell>
              </TableRow>
            </TableHead>
            {coownerDetail.contacts.length > 0
              ? coownerDetail.contacts.map((contact) => (
                  <TableRow key={coownerDetail.id}>
                    <TableCell component="th">{contact.fullName}</TableCell>
                    <TableCell>{contact.mail || '-'}</TableCell>
                    <TableCell>{contact.street || '-'}</TableCell>
                    <TableCell>
                      {formatTownAndZipCode(contact.town, contact.zipCode)}
                    </TableCell>
                  </TableRow>
                ))
              : 'Pas de contact pour ce copropriétaire.'}
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              closeDialog()
            }}
          >
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
